const styles = (theme) => ({
  header: {
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    lineHeight: '19px',
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    borderTop: `1px solid ${theme.AppBGColor}`
  },
  tabRoot: {
    textTransform: 'none',
    fontSize: theme.headerTextFontSize,
    color: theme.HeaderSelectedText,
    opacity: 1,
    fontWeight: 600,
    '&$tabSelected': {
      color: theme.HeaderSelectedText,
    },
    '&:hover': {
      color: theme.HeaderSelectedText,
      opacity: 1,
    },
    '&$tabDisabled': {
      color: theme.disabledColor,
      opacity: 0.8,
      cursor: 'not-allowed'
    }
  },
  tabSelected: {},
  tabDisabled: {},
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    position: 'relative',
    overflowY: 'auto'
  },
});

export default styles;
